import { withSnackbar } from "./withSnackbar";
import { useSnackbar } from "./useSnackbar";
import { Provider } from "./Provider";

export { Provider as SnackbarProvider } from "./Provider";
export { withSnackbar } from "./withSnackbar";
export { useSnackbar } from "./useSnackbar";

export const Snackbar = {
  Provider,
  withSnackbar,
  useSnackbar,
};
